import axios from '@/utils/api'

const actions = {

  async getProcessosByMunicipio ({ context }) {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/processos/processosByMunicipio'
    })

    return data
  },

  async getAllStatusProcessos ({ context }) {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/processos/getAllStatusProcesso'
    })

    return data
  },

  async getProcessosByMes ({ context }) {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/processos/processosByMes'
    })

    return data
  },

  async getProcessosCadastrados (context) {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/processos/count'
    })

    return data
  },

  async getListaProcessosCadastrados (context, status) {
    const data = await axios({
      method: 'GET',
      url: `relatorios/processos/lista/${status}`
    })

    return data
  },

  async getListaProcessosSetor (context) {
    const data = await axios({
      method: 'GET',
      url: `relatorios/processos/setor`
    })

    return data
  },

  async getFilterInfo (context) {
    const data = await axios({
      method: 'GET',
      url: `relatorios/processos/filterInfo`
    })
    return data
  },

  async getTecnicosResponsaveis (context, codigosSetores) {
    const data = await axios({
      method: 'POST',
      url: `relatorios/processos/tecnicos`,
      data: codigosSetores,
      loader: false
    })
    return data
  },

  async findProcessosByFilter (context, filter) {
    const data = await axios({
      method: 'POST',
      url: `relatorios/processos/findByFilter`,
      data: filter,
      loader: false
    })
    return data
  },

  async downloadModelo ({ commit }, codigo) {
    await axios({
      method: 'get',
      url: `publico/arquivo/modeloRelatorio`,
      responseType: 'blob'
    })
  },

  // Exporta csv com o filtro escolhido
  async getCsvDashboardRelatorios({ commit }, filtro) { // eslint-disable-line
    return axios({
      method: 'POST',
      url: 'relatorios/processos/exportarCsvPesquisaRelatorio',
      responseType: 'blob',
      data: {
        ...filtro
      },
      loader: false
    })
  },

  async getCsvDashboardRelatoriosAp({ commit }, filtro) { // eslint-disable-line
    return axios({
      method: 'POST',
      url: 'relatorios/processos/exportarCsvPesquisaRelatorioAp',
      responseType: 'blob',
      data: {
        ...filtro
      },
      loader: false
    })
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/relatorios/dashboardRelatorios.js